module.exports = __webpack_public_path__ + "img/BecomeIns-mob1.ef46887b.svg";